import styled from 'styled-components'

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  top: 5px;
  left: 10px;
`
export const DropdownButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
`
export const DropdownContent = styled.div<{ isMenuOpen: boolean }>`
  display: ${({ isMenuOpen }) => (isMenuOpen ? 'block' : 'none')};
  position: absolute;
  top: 35px;
  right: 5px;
  padding: 10px 20px;
  background: #ffffff;
  width: 360px;
  box-sizing: 0 5px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  transition: 0.5s;
  border: 1px solid #e8eaea;

  @media (max-width: 1024px) {
    width: 300px;
    right: -60px;
  }
`
